import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, spacing, radius, fontSize, fonts } = redesignTheme;

export const useAccountConfirmContentStyles = makeStyles(() => ({
  infoBox: {
    backgroundColor: colors.accentMuted,
    borderRadius: radius.sm,
    padding: spacing.sm,
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    textAlign: 'left',
    width: '100%',
    boxSizing: 'border-box' as const,
  },
  infoIcon: {
    fontSize: 20,
    color: colors.primaryDark,
    flexShrink: 0,
  },
  infoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  infoTitle: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
  },
  infoText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    lineHeight: 1.5,
    color: colors.primaryDark,
    margin: 0,
  },
  horizontalRule: {
    width: '100%',
    height: 1,
    backgroundColor: colors.border,
  },
  noEmailText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    margin: 0,
    width: '100%',
    textAlign: 'left',
  },
}));
